import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomLegend = ({ legendItems }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      {legendItems?.map(legendItem => (
        <Styles.LegendContainer key={legendItem.label}>
          {legendItem.type === 'square' && <Styles.LegendSquare backgroundColor={legendItem.color} />}
          {legendItem.type === 'line' && <Styles.LegendLine backgroundColor={legendItem.color} />}

          <Text type="bodySRegular">{t(legendItem.label)}</Text>
        </Styles.LegendContainer>
      ))}
    </Styles.Container>
  )
}

export default CustomLegend
